module.exports = __webpack_public_path__ + "img/01.b39821b0.png";